import { Box } from "@mui/material";
import React from "react";
import AdminHolidayCalender from "../component/AdminHolidayCalender";

const EventCalendar = ({
  responseData,
  eventContent,
  eventClick,
  onMonthChange,
}) => {
  // Map through responseData to create event objects with all necessary properties
  const events = responseData.map((event) => {
    let backgroundColor = "#E9E9E9"; // Default color
    let color = "#0A0B0A"; // Default text color
    let borderRadius = "10px";
    let width = "100%";
    let height = "100%";
    let cursor = "pointer";
    const isRestricted = event.restrictedHoliday?.toLowerCase() === "yes";

    // Set colors based on the restrictedHoliday property
    if (!isRestricted) {
      backgroundColor = "#EEF5FC";
      color = "#092C4C";
      cursor = "pointer";
    } else {
      backgroundColor = "#FEF4DA";
      color = "#E3B53E";
    }

    return {
      id: event.id,
      title: event.occasion,
      start: event.date,
      backgroundColor,
      textColor: color,
      extendedProps: {
        id: event.id,
        title: event.occasion,
        date: event.date,
        discription: event.discription,
        occasion: event.occasion,
        restrictedHoliday: event.restrictedHoliday,
        allState: event.allState,
        allLocation: event.allLocation,
        stateList: event.stateList,
        locations: event.locationList,
        file: event.file,
        width,
        height,
        borderRadius,
      },
      classNames: [
        (event.occasion || "").replace(/\s+/g, "-").toLowerCase(),
        isRestricted ? "restrictedHoliday" : "",
        "custom-event",
      ],
    };
  });

  return (
    <Box>
      <AdminHolidayCalender
        events={events}
        eventContent={eventContent}
        eventClick={eventClick}
        onMonthChange={onMonthChange}
      />
    </Box>
  );
};

export default EventCalendar;
